module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel5-1f12e935644b163341e16f9ab92b5bbe.jpg";